export const errorFeedbackStyle = {
  minHeight: "1.25rem",
  marginTop: "0.25rem",
  display: "block",
  fontSize: "0.75rem",
  color: "#dc3545"
};